import {
  Briefcase,
  ChatCircleText,
  Compass,
  Database,
  Gear,
  ShareNetwork,
  Television,
  TreeStructure,
} from '@phosphor-icons/react';

export const ALL_ROLES = ['participant', 'facilitator', 'executive', 'super_admin', 'admin', 'viewer', 'board_director'];

export const PRIMARY_NAV = [
  { to: '/boardroom', label: 'Boardroom', icon: Television, roles: ALL_ROLES },
  { to: '/work', label: 'Work', icon: Compass, roles: ALL_ROLES },
  { to: '/execution', label: 'Execution', icon: TreeStructure, roles: ALL_ROLES },
  { to: '/intelligence', label: 'Intelligence', icon: Database, roles: ALL_ROLES },
  { to: '/chat', label: 'Chat', icon: ChatCircleText, roles: ALL_ROLES },
  { to: '/data', label: 'Data', icon: Database, roles: ALL_ROLES },
  { to: '/enterprise', label: 'Enterprise', icon: Briefcase, roles: ALL_ROLES },
];

export const SETTINGS_NAV = { to: '/settings', label: 'Settings', icon: Gear, roles: ALL_ROLES };

const SEARCH_BY_SURFACE = {
  '/boardroom': 'Filter boardroom signals',
  '/work': 'Search work',
  '/execution': 'Search execution workspace and project graph',
  '/intelligence': 'Search intelligence',
  '/chat': 'Search organizational intelligence',
  '/data': 'Search sources and imports',
  '/enterprise': 'Search administration',
};

function surfaceFor(pathname) {
  return PRIMARY_NAV.find((item) => pathname === item.to || pathname.startsWith(`${item.to}/`));
}

export function routeAccess(pathname, role) {
  if (role === 'board_director' || role === 'super_admin') return true;
  if (pathname === '/settings') return SETTINGS_NAV.roles.includes(role);
  const surface = surfaceFor(pathname);
  return surface ? surface.roles.includes(role) : true;
}


export function contextualSearch(pathname) {
  const surface = Object.keys(SEARCH_BY_SURFACE).find((path) => pathname === path || pathname.startsWith(`${path}/`));
  return surface ? SEARCH_BY_SURFACE[surface] : null;
}
